<template>
  <div class="section-category section-bg">
    <div class="inner-note set-permission-staff">
      <h3 v-translate>Commission</h3>
      Enter Staff ID
      <input-pad
        :item="this"
        :property="'staffRef'"
        :maxLength="5"
        :alphabetable="true"
        :attributes="{
            'class': 'set-permission-staff'
          }"/><br>
      <div class="btns-footer mt-3">
        <button ref="confirm" class="btn btn-primary" @click="onConfirm" v-translate>Confirm</button>
        <button class="btn btn-cancel" @click="onCancel" v-translate>Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  SET_MESSAGE_MODAL,
  SET_ACTIVE_ELEMENT,
} from '@/store/mutation-types';
import CommissionService from '@/services/CommissionService';

export default {
  name: 'SetCommission',
  props: ['product', 'force'],
  data() {
    return {
      staffRef: null,
      setCommission: false
    };
  },
  destroyed() {
    if (!this.setCommission && this.force) {
      this.removeLastLine();
    }
  },
  computed: {
    ...mapGetters(
      [
        'removeLastLine',
      ],
    ),
  },
  methods: {
    async onConfirm() {
      if (!this.staffRef) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Please enter Staff'));
        return;
      }
      const commission = this.$store.getters.getArticleCommission(this.product);
      const staff = this.getObject(this.staffRef, 'staffs', 'ref');
      if (!staff) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Invalid Staff for this commission'));
        return;
      }
      const checkStaff = this.$store.getters.checkStaff(staff.id);
      if (!checkStaff.valid) {
        this.$store.commit(SET_MESSAGE_MODAL, checkStaff.data.message);
        return;
      }
      const staffGroups = typeof (commission.data) === 'object' ? commission.data : JSON.parse(commission.data);
      let staffGroupData = null;
      if (!staffGroups[staff.userGroup]) {
        if (!staffGroups[0]) {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Invalid Staff for this commission'));
          return;
        }
        staffGroupData = staffGroups[0];
      } else {
        staffGroupData = staffGroups[staff.userGroup];
      }
      staffGroupData.commissionId = commission.id;
      this.$store.getters.addCommission(staff.id, staffGroupData);
      this.setCommission = true;
      this.$router.push('order');
    },
    onCancel() {
      this.$router.push('order');
    },
  },
  created() {
    console.log(this.force);
    if (!this.product) {
      this.$router.push('order');
    }
  },
};
</script>
